// @flow
export { default } from './PartnerToc';



// WEBPACK FOOTER //
// ./src/components/partner/PartnerToc/index.js